import { createSlice } from "@reduxjs/toolkit";
import { reducers } from "../../constants/appConstants";

const initialState = {
  data: [],
};

export const jobSlice = createSlice({
  name: reducers.job,
  initialState,
  reducers: {
    saveData: (state, action) => {
      state.data = action.payload;
    },
    updateData: (state, action) => {
      state.data = [...state.data, action.payload];
    },
    clearData: (state) => {
      state.data = [];
    },
  },
});

export const { saveData, clearData, updateData } = jobSlice.actions;

export default jobSlice;
